import styled from 'styled-components';
import { Space } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { getSize, getColor } from '@lib/common';
import { MathEnabledTextComponent, RichTextEditor, PrimaryButton, SecondaryButton } from '@lib/common';
import { useState, useRef, useEffect } from 'react'; // Styles

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__StyledWrapper",
  componentId: "sc-1gu9jat-0"
})(["margin-top:", ";", ""], getSize('padding16'), function (_ref) {
  var $isEmpty = _ref.$isEmpty;
  return $isEmpty && "\n      display: none;\n    ";
});
export var DescriptionPreviewWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__DescriptionPreviewWrapper",
  componentId: "sc-1gu9jat-1"
})(["cursor:", ";width:100%;overflow:hidden;word-wrap:break-word;overflow-wrap:break-word;white-space:", ";max-height:", ";img{max-width:100%;height:auto;}"], function (_ref2) {
  var $readonly = _ref2.$readonly;
  return $readonly ? 'default' : 'text';
}, function (_ref3) {
  var $preserveLineBreaks = _ref3.$preserveLineBreaks;
  return $preserveLineBreaks ? 'pre-wrap' : 'normal';
}, function (_ref4) {
  var $isExpanded = _ref4.$isExpanded,
      $collapsedMaxHeight = _ref4.$collapsedMaxHeight;
  return $isExpanded ? 'none' : $collapsedMaxHeight !== null && $collapsedMaxHeight !== void 0 ? $collapsedMaxHeight : 'none';
});
var StyledExpandCollapseButton = styled.button.withConfig({
  displayName: "card-descriptioncomponent__StyledExpandCollapseButton",
  componentId: "sc-1gu9jat-2"
})(["display:flex;align-items:center;gap:", ";margin-top:", ";padding:0;background:none;border:none;color:", ";font-size:", ";font-weight:600;cursor:pointer;&:hover{opacity:0.8;}"], getSize('padding4'), getSize('padding8'), getColor('fillIntActive'), getSize('typo14'));
export var StyledGroupButton = styled(Space).withConfig({
  displayName: "card-descriptioncomponent__StyledGroupButton",
  componentId: "sc-1gu9jat-3"
})(["display:flex;justify-content:flex-end;margin-top:", ";"], getSize('padding16'));
export var DescriptionEditorWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__DescriptionEditorWrapper",
  componentId: "sc-1gu9jat-4"
})(["width:100%;overflow:visible;"]); // Component

export var CardDescription = function CardDescription(_ref5) {
  var description = _ref5.description,
      _ref5$preserveLineBre = _ref5.preserveLineBreaks,
      preserveLineBreaks = _ref5$preserveLineBre === void 0 ? false : _ref5$preserveLineBre,
      _ref5$isEditing = _ref5.isEditing,
      isEditing = _ref5$isEditing === void 0 ? false : _ref5$isEditing,
      _ref5$isReadonly = _ref5.isReadonly,
      isReadonly = _ref5$isReadonly === void 0 ? false : _ref5$isReadonly,
      placeholder = _ref5.placeholder,
      onChange = _ref5.onChange,
      onSave = _ref5.onSave,
      onCancel = _ref5.onCancel,
      _ref5$saveLabel = _ref5.saveLabel,
      saveLabel = _ref5$saveLabel === void 0 ? 'Save' : _ref5$saveLabel,
      _ref5$cancelLabel = _ref5.cancelLabel,
      cancelLabel = _ref5$cancelLabel === void 0 ? 'Cancel' : _ref5$cancelLabel,
      editorLabels = _ref5.editorLabels,
      onAddImage = _ref5.onAddImage,
      onAddAudio = _ref5.onAddAudio,
      richTextEditorRef = _ref5.richTextEditorRef,
      _ref5$hideButtons = _ref5.hideButtons,
      hideButtons = _ref5$hideButtons === void 0 ? false : _ref5$hideButtons,
      _ref5$isShowingExtend = _ref5.isShowingExtendOrCollapse,
      isShowingExtendOrCollapse = _ref5$isShowingExtend === void 0 ? false : _ref5$isShowingExtend,
      _ref5$collapsedMaxHei = _ref5.collapsedMaxHeight,
      collapsedMaxHeight = _ref5$collapsedMaxHei === void 0 ? '100px' : _ref5$collapsedMaxHei,
      _ref5$expandLabel = _ref5.expandLabel,
      expandLabel = _ref5$expandLabel === void 0 ? 'Mở rộng' : _ref5$expandLabel,
      _ref5$collapseLabel = _ref5.collapseLabel,
      collapseLabel = _ref5$collapseLabel === void 0 ? 'Thu gọn' : _ref5$collapseLabel;

  var _useState = useState(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useState2 = useState(false),
      isOverflowing = _useState2[0],
      setIsOverflowing = _useState2[1];

  var contentRef = useRef(null);
  useEffect(function () {
    if (!contentRef.current || !isShowingExtendOrCollapse || isExpanded) return;
    var el = contentRef.current;
    setIsOverflowing(el.scrollHeight > el.clientHeight);
  }, [description, isShowingExtendOrCollapse, isExpanded]);

  if (isEditing) {
    return /*#__PURE__*/_jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsxs(DescriptionEditorWrapper, {
        children: [/*#__PURE__*/_jsx(RichTextEditor, {
          ref: richTextEditorRef,
          placeholder: placeholder,
          content: description,
          editorLabels: editorLabels,
          addImage: onAddImage,
          addAudio: onAddAudio,
          onChange: onChange
        }), !hideButtons && /*#__PURE__*/_jsxs(StyledGroupButton, {
          children: [/*#__PURE__*/_jsx(SecondaryButton, {
            onClick: onCancel,
            children: cancelLabel
          }), /*#__PURE__*/_jsx(PrimaryButton, {
            onClick: onSave,
            children: saveLabel
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/_jsxs(StyledWrapper, {
    $isEmpty: !description,
    children: [/*#__PURE__*/_jsx(DescriptionPreviewWrapper, {
      ref: contentRef,
      $readonly: isReadonly,
      $isExpanded: isShowingExtendOrCollapse ? isExpanded : undefined,
      $collapsedMaxHeight: isShowingExtendOrCollapse ? collapsedMaxHeight : undefined,
      $preserveLineBreaks: preserveLineBreaks,
      children: /*#__PURE__*/_jsx(MathEnabledTextComponent, {
        value: description
      })
    }), isShowingExtendOrCollapse && isOverflowing && /*#__PURE__*/_jsx(StyledExpandCollapseButton, {
      type: "button",
      onClick: function onClick() {
        return setIsExpanded(function (prev) {
          return !prev;
        });
      },
      children: isExpanded ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UpOutlined, {}), " ", collapseLabel]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(DownOutlined, {}), " ", expandLabel]
      })
    })]
  });
};